/*
* Component for a small bell which sits in the top right of an organisation card that allows the user to follow an organisation.
*/
<template>
  <span :class="classes" @click="doClick" :title="(existing_alert) ? 'Modify Alert' :'Create Alert'" aria-label="Create Alert">
    <block-spinner :active="isLoading" size="3" color="text-red-esc" :key="`spinner_${existing_alert}`"></block-spinner>
    <svg v-if="!isLoading" class="btn-alert-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 13"><path d="M5.25 12.5c.82 0 1.5-.656 1.5-1.5h-3c0 .844.656 1.5 1.5 1.5zm5.04-3.492c-.446-.492-1.313-1.219-1.313-3.633C8.977 3.57 7.71 2.117 6 1.742V1.25A.771.771 0 005.25.5a.755.755 0 00-.75.75v.492c-1.734.375-3 1.828-3 3.633 0 2.414-.867 3.14-1.313 3.633A.687.687 0 000 9.5c0 .398.305.75.75.75h8.977c.468 0 .75-.352.773-.75a.715.715 0 00-.21-.492z"></path></svg>
  </span>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'Alert',

    mixins: [AuthMixins],

   	props: {
			org_main_id: {
				type: String
			},
			org_name: {
        type: String,
      }
		},

   	data() {
      return {
        saved_alerts: false,
        isLoading: false
      }
    },

    created() {

    },

    methods: {
      doClick() {
        if (this.me) {
	        if (!this.existing_alert) {
	        	this.isLoading = true;

	        	// Alert has not been made yet.
		        let query = encodeURIComponent('org-name=' + this.org_name);
						let payload = {
			  			'org-main-id': this.org_main_id,
							'query': query,
							'title': this.org_name + ' jobs',
							'frequency': 'Weekly'
			  		}

			  		return this.$api.followOrganisation(payload).then(
			        (response) => {
			        	if (response.data.status == 'success') {
			        		this.updateUser(response.data.enc_user);
			        		this.emitter.emit("openModal", { name: 'AlertCreated', 'job_alert_id': response.data['job_alert_id'] });
			        		this.isLoading = false;
			        	}
			        }
			      ).catch((response) => {
			        console.log("Could not follow this organisation.", response);
			      });
			    } else {
			    	// Alert already created, just open the edit panel.
			    	this.emitter.emit("openModal", { name: 'EditSavedSearchAlert', 'job_alert_id': this.existing_alert.id });
			    }
			  } else {
	    		this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
	    	}
	    }

    },

    computed: {
      classes() {
        return {
          'btn-alert': true,
          'active': this.existing_alert,
        }
      },
			existing_alert() {
				if(this.saved_alerts) {
					let found = this.saved_alerts.find((alert) => {
						return alert['org-main-id'] == this.org_main_id;
					});
					return (found);
				}
			}
    },
    watch: {
    	me() {
    		this.saved_alerts = (this.$store.getters.getUser['saved-alerts'] !== undefined) ? this.$store.getters.getUser['saved-alerts'] : false;
    	}
    }
  };
</script>
